import { ClipLoaderCommon } from "@components";
import { IBookingCheckInData } from "@interfaces";
import { theme } from "@utilities";
import styled from "styled-components";

export interface IPickUpDetailsMessageProps {
    isWithCustomBookingTimeIDs: boolean;
    selectedBookingTimeId: string;
    checkInOptions?: IBookingCheckInData | null;
}

export interface IPickUpDetailsButtonProps {
    isDetailsOpen: boolean;
    isMobileView: boolean;
    toggleDetails: () => void;
    pickUpDetailsComp: React.ReactNode;
}

export const PickUpDetailsButton = ({
    isDetailsOpen,
    isMobileView,
    toggleDetails,
    pickUpDetailsComp,
}: IPickUpDetailsButtonProps) => {
    const handleToggle = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        toggleDetails();
    };

    return (
        <div
            className={`${isDetailsOpen && isMobileView ? "container-background" : ""} pick-up-wrapper`}
        >
            <div className="details-container" onClick={handleToggle} style={{ cursor: "pointer" }}>
                <img src="/images/Info.svg" alt="info" />
                <span>Pick Up Details</span>
                <button
                    onClick={handleToggle}
                    style={{ background: "none", border: "none", cursor: "pointer" }}
                >
                    <img
                        src="/images/Chevron-Down.svg"
                        alt="chevron"
                        className={`chevron ${isDetailsOpen ? "" : "rotated"}`}
                    />
                </button>
            </div>
            {isMobileView && isDetailsOpen && pickUpDetailsComp}
        </div>
    );
};

export const PickUpDetailsMessage = (props: IPickUpDetailsMessageProps) => {
    const { isWithCustomBookingTimeIDs, selectedBookingTimeId, checkInOptions } = props;

    return (
        <PickUpDetailsContainer>
            {!checkInOptions ? (
                <ClipLoaderCommon color={theme.colors.highlight} size={70} margin={150} />
            ) : (
                <>
                    {checkInOptions.pickupTimes
                        .flatMap((pt) =>
                            pt.options.filter((opt) =>
                                isWithCustomBookingTimeIDs
                                    ? true
                                    : opt.id === selectedBookingTimeId,
                            ),
                        )
                        .map((opt) => (
                            <>
                                <p>Time: {opt.displayName}</p>
                                {checkInOptions.pickupLocations
                                    .filter((pl) => pl.upstreamTimeRef === opt.downstreamTimeRef)
                                    .flatMap((pl) => pl.options)
                                    .map((plOpt) => (
                                        <p>Pickup: {plOpt.displayName}</p>
                                    ))}
                                {checkInOptions.dropoffLocations
                                    .filter((dl) => dl.upstreamTimeRef === opt.downstreamTimeRef)
                                    .flatMap((dl) => dl.options)
                                    .map((dlOpt) => (
                                        <p>Dropoff: {dlOpt.displayName}</p>
                                    ))}
                            </>
                        ))}
                </>
            )}
        </PickUpDetailsContainer>
    );
};

const PickUpDetailsContainer = styled.div`
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.5;
`;
